import { useMemo, useContext } from 'react';
import { PatientChartContext } from '../../../contexts/patientChart';
import {
  MODAL_KEY, CONFIRMATION_POPUP_KEY, SOAP_TEMPLATES, SOAP, RESPONSE_POPUP_KEY,
  PATIENT_TOKEN_MAPPING, PATIENT,
} from '../../../constants/patientChart.constant';
import PPButton from '../../subComponents/button';
import Select from '../../subComponents/select';
import { POPUP_TYPE } from '../../subComponents/popup';

export const AddSoapNote = ({
  orderId = 0,
  patientId = 0,
  patient = PATIENT(),
  soapTemplates = SOAP_TEMPLATES(),

  addSoapNote = async (requestBody = {}) => {},
  setSoapNoteAdded = async (requestBody = {}) => {},
  getNotesTabInfo = async () => {},
}) => {
  const {
    soap,
    setSoap,
    loading,
    setLoading,
    handleModalOpen,
    handleMultipleModalClose,
  } = useContext(PatientChartContext);

  const stopLoading = (_loading) => {
    const __loading = new Set(_loading);
    __loading.delete(MODAL_KEY.SOAP_NOTE);
    setLoading(__loading);
  }

  const handleChange = ({ target }) => {
    const value = Number(target.value);
    const template = soapTemplates.valuesCollection.get(value) || { description: '' };
    let description = template.description;

    for (let i = 0; i < PATIENT_TOKEN_MAPPING.length; i++) {
      const { key, target } = PATIENT_TOKEN_MAPPING[i];
      const regex = new RegExp(`(${key})`, 'gmi');
      description = description.replace(regex, patient[target] || '');
    }

    setSoap({ ...soap, value: value, note: description });
  };

  const handleMessageChange = ({ target }) => {
    setSoap({ ...soap, note: target.value });
  };

  const handleAddSoapNote = async ({ key }) => {
    const _loading = new Set(loading);
    _loading.add(MODAL_KEY.SOAP_NOTE);
    setLoading(_loading);

    try {
      const requestBody = {
        OrderId: orderId,
        PatientId: patientId,
        NoteText: soap.note,
      };
      const { status, data } = await addSoapNote(requestBody);
      if (status === 200) {
        setSoapNoteAdded({ name: 'soapNoteInfo', value: true });
        stopLoading(_loading);
        setSoap(SOAP());
        handleMultipleModalClose.call(this, { keys: [key, MODAL_KEY.SOAP_NOTE] });

        // reload the notes
        getNotesTabInfo();
      }

      if (status !== 200) {
        const { Error: error = 'Failed to add soap note. Please try later.' } = data;
        const heading = 'Error';

        handleModalOpen({
          key: RESPONSE_POPUP_KEY.SOAP_NOTE,
          modal: {
            heading,
            type: POPUP_TYPE.ERROR,
            message: error,
          }
        });
      }
    } catch(e) {

    } finally {
      stopLoading(_loading);
    }
  };

  const Template = (
    <div className='flex flex-column gap-20 flex-fill m-b-5'>
      <div className='flex flex-column gap-12'>
        <label className="input-label min-width-110 m-r-4">SOAP Template:</label>
        <Select
          id='templateId'
          labelId="templateId"
          value={soap.value}
          onChange={handleChange}
          items={soapTemplates.api.data}
        />
      </div>

      <div className='flex flex-column gap-12 flex-fill'>
        <label className="input-label min-width-110 m-r-4">Order Note:</label>
        <textarea
          name='orderNote'
          className='flex flex-fill border-light-grey-1 min-height-160 height-full p-4 font-proxima-nova font-16 color-dark-grey border-box resize-none'
          wrap='soft'
          maxLength={4000}
          spellCheck={true}
          value={soap.note}
          onChange={handleMessageChange}
        />
      </div>
    </div>
  );

  const _disabled = useMemo(() => (soap.note.length === 0), [soap.note]);
  const _loading = useMemo(() => loading.has(MODAL_KEY.SOAP_NOTE), [loading]);

  const Actions = (
    <div className='flex justify-content-flex-end'>
      <PPButton label='Add SOAP Note' variant='contained' loading={_loading} disabled={_disabled} endGutter onClick={handleAddSoapNote.bind(this, { key: CONFIRMATION_POPUP_KEY.SOAP_NOTE, modal: {} })} />
      <PPButton label='Cancel' variant='cancel' disabled={_loading} onClick={handleMultipleModalClose.bind(this, { keys: [MODAL_KEY.SOAP_NOTE] })} />
    </div>
  );

  return (
    <div className='flex flex-column flex-fill m-5 patient-chart-container'>
      {Template}
      {Actions}
    </div>
  );
};

export default AddSoapNote;
